import { Component } from 'react';
/**
 * Abstract class for the {@code Label} component.
 */
export default class Label extends Component {
}
